"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var category_item_dto_1 = require("../item/dto/category-item-dto");
var date_category_type_1 = require("../item/type/date-category-type");
var measure_item_dto_1 = require("../item/dto/measure-item-dto");
var filter_type_1 = require("./type/filter-type");
var filter_type_option_1 = require("./type/filter-type-option");
var filter_type_options_1 = require("./type/filter-type-options");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var Observable_1 = require("rxjs/Observable");
var common_filter_component_1 = require("../../../controls/common-filter/common-filter.component");
var filter_helper_1 = require("../helper/filter-helper");
var FilterItem = /** @class */ (function () {
    function FilterItem(_parent, criterionValidator, item, filterType) {
        if (item === void 0) { item = null; }
        if (filterType === void 0) { filterType = null; }
        this._parent = _parent;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(_parent);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(criterionValidator);
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(item);
        idm_common_util_frontend_1.PreconditionCheck.notUndefined(filterType);
        this.clearState();
        this._criterionValidator = criterionValidator;
        this._item = item;
        this._filterType = filterType;
        this.initState();
    }
    Object.defineProperty(FilterItem.prototype, "criterionValidator", {
        get: function () {
            return this._criterionValidator;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterItem.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (item) {
            idm_common_util_frontend_1.PreconditionCheck.notUndefined(item);
            this._item = item;
            // when item set to null, validate filters
            if (this._item === null) {
                this.clearState();
                this.resetValiditySubscription();
                this.parent.validate();
            }
            this._filterType = null;
            this.filterType = this.getDefaultFilterType();
            this.resetFilterTypeComboboxSubscription();
            this.clearCategoryComboboxSubscription();
            if (this.item instanceof category_item_dto_1.CategoryItemDto && this.item.dateCategoryType !== date_category_type_1.DateCategoryType.DAY && !this.isIndicatorCategory()) {
                this.resetCategoryValuesSubscription(this.item);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterItem.prototype, "filterType", {
        get: function () {
            return this._filterType;
        },
        set: function (filterType) {
            idm_common_util_frontend_1.PreconditionCheck.notUndefined(filterType);
            var isInitialChange = !this._filterType;
            if (!isInitialChange && !filterType) {
                filterType = this.getDefaultFilterType();
            }
            this._filterType = filterType;
            this.criterion = this.initCriterion();
            if (!isInitialChange || !this.isFilterValueRequired()) {
                this.validate();
            }
            else {
                this.criterionValidator.clearValidations();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterItem.prototype, "criterion", {
        get: function () {
            return this._criterion;
        },
        set: function (criterion) {
            this._criterion = criterion;
            this._isCriterionValidated = false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterItem.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterItem.prototype, "timelineCategoryMessageKey", {
        get: function () {
            var messageKey = '';
            var item = this.item;
            if (item instanceof category_item_dto_1.CategoryItemDto) {
                var messageKeyTemplate = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["reporting.controls.filter.text.date.", "s"], ["reporting.controls.filter.text.date.", "s"])), 'dateCategoryType');
                messageKey = messageKeyTemplate.replaceTemplate({
                    'dateCategoryType': date_category_type_1.DateCategoryType[item.dateCategoryType]
                });
            }
            return messageKey;
        },
        enumerable: true,
        configurable: true
    });
    FilterItem.prototype.clearState = function () {
        this._criterion = null;
        this._isCriterionValidated = false;
        this.clearValiditySubscription();
        this.clearFilterTypeComboboxSubscription();
        this.clearCategoryComboboxSubscription();
        this.filterTypeComboboxOptions = [];
        this.categoryComboboxOptions = [];
    };
    FilterItem.prototype.isForCategory = function (itemType, filterType) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(itemType);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterType);
        return this.item instanceof category_item_dto_1.CategoryItemDto && this.item.categoryType === itemType && this.filterType === filterType;
    };
    FilterItem.prototype.isForCategoryTimeline = function (dateCategoryType) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(dateCategoryType);
        return this.item instanceof category_item_dto_1.CategoryItemDto && this.item.dateCategoryType === dateCategoryType;
    };
    FilterItem.prototype.isForMeasure = function (measureType, filterType) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(measureType);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(filterType);
        return this.item instanceof measure_item_dto_1.MeasureItemDto && this.item.measureType === measureType && (!filterType || this.filterType === filterType);
    };
    FilterItem.prototype.validate = function () {
        if (this.isTemporary()) {
            this.criterionValidator.validity = true;
        }
        else {
            this.criterion.accept(this.criterionValidator);
        }
    };
    FilterItem.prototype.isTemporary = function () {
        var result = true;
        if (this.criterion) {
            result = false;
        }
        return result;
    };
    FilterItem.prototype.requiresCriterionValidation = function () {
        return !this.isTemporary() && !this.isCriterionValidated();
    };
    FilterItem.prototype.initState = function () {
        var _this = this;
        if (!this.filterType) {
            this.filterType = this.getDefaultFilterType();
        }
        this.resetValiditySubscription();
        this.resetFilterTypeComboboxSubscription();
        if (this.item instanceof category_item_dto_1.CategoryItemDto && this.item.dateCategoryType !== date_category_type_1.DateCategoryType.DAY && !this.isIndicatorCategory()) {
            this.resetCategoryValuesSubscription(this.item);
        }
        // Validate initial state.
        if (this.item || this.filterType) {
            var isValid = this.filterTypeComboboxOptions.some(function (option) {
                return option.value === _this.filterType;
            });
            if (!isValid) {
                throw new Error('Provided \'filterType\' is not compatible with provided \'item\'.');
            }
        }
    };
    FilterItem.prototype.getDefaultFilterType = function () {
        var defaultOption = null;
        if (this.item instanceof category_item_dto_1.CategoryItemDto) {
            defaultOption = filter_type_options_1.FilterTypeOptions.defaultOfCategory(this.item.categoryType, this.item.dateCategoryType);
        }
        else if (this.item instanceof measure_item_dto_1.MeasureItemDto) {
            defaultOption = filter_type_options_1.FilterTypeOptions.defaultOfMeasure(this.item.measureType);
        }
        return defaultOption ? defaultOption.value : null;
    };
    FilterItem.prototype.initCriterion = function () {
        if (!this.item || !this.filterType || !this.criterionValidator) {
            return null;
        }
        return filter_helper_1.FilterHelper.criterionFor(this);
    };
    FilterItem.prototype.clearValiditySubscription = function () {
        if (this.validitySubscription) {
            this.validitySubscription.unsubscribe();
        }
        this.validitySubscription = null;
    };
    FilterItem.prototype.resetValiditySubscription = function () {
        var _this = this;
        this.clearValiditySubscription();
        this.validitySubscription = this.criterionValidator.isValid
            .subscribe(function (isValid) {
            if (!_this.isTemporary()) {
                _this._isCriterionValidated = true;
            }
        });
    };
    FilterItem.prototype.clearFilterTypeComboboxSubscription = function () {
        if (this.filterTypeComboboxSubscription) {
            this.filterTypeComboboxSubscription.unsubscribe();
        }
        this.filterTypeComboboxSubscription = null;
    };
    FilterItem.prototype.resetFilterTypeComboboxSubscription = function () {
        var _this = this;
        this.clearFilterTypeComboboxSubscription();
        this.filterTypeComboboxOptions = this.initFilterTypeComboboxOptions();
        var messageObservables = this.filterTypeComboboxOptions
            .map(function (option) {
            return _this.parent.messageService.getMessage(option.name);
        });
        this.filterTypeComboboxSubscription = Observable_1.Observable
            .zip.apply(Observable_1.Observable, [this.parent.currentLanguageProvider.getCurrentLanguage()].concat(messageObservables)).subscribe(function () {
            _this.filterTypeComboboxOptions = _this.filterTypeComboboxOptions
                .map(function (option) {
                return filter_type_option_1.FilterTypeOption.from(option);
            });
        });
    };
    FilterItem.prototype.initFilterTypeComboboxOptions = function () {
        var options = [];
        if (this.item instanceof category_item_dto_1.CategoryItemDto) {
            options = filter_type_options_1.FilterTypeOptions.ofCategory(this.item.categoryType, this.item.dateCategoryType);
        }
        else if (this.item instanceof measure_item_dto_1.MeasureItemDto) {
            options = filter_type_options_1.FilterTypeOptions.ofMeasure(this.item.measureType);
        }
        return options;
    };
    FilterItem.prototype.clearCategoryComboboxSubscription = function () {
        if (this.categoryComboboxSubscription) {
            this.categoryComboboxSubscription.unsubscribe();
        }
        this.categoryComboboxSubscription = null;
    };
    FilterItem.prototype.resetCategoryComboboxSubscription = function (itemId) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(itemId);
        this.clearCategoryComboboxSubscription();
        this.categoryComboboxSubscription = this.parent.valueLoader.getCategoryValues(itemId)
            .subscribe(function (values) {
            _this.categoryComboboxOptions = common_filter_component_1.CommonFilterComponent.initSimpleComboboxOptions(values);
        });
    };
    FilterItem.prototype.resetCategoryValuesSubscription = function (itemDto) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(itemDto);
        this.categoryComboboxOptions = [];
        if (!itemDto.searchable) {
            this.resetCategoryComboboxSubscription(itemDto.id);
        }
    };
    FilterItem.prototype.isCriterionValidated = function () {
        return this._isCriterionValidated;
    };
    FilterItem.prototype.isFilterValueRequired = function () {
        switch (this.filterType) {
            case filter_type_1.FilterType.CURRENT:
            case filter_type_1.FilterType.CURRENT_USER:
            case filter_type_1.FilterType.NOT_CURRENT:
            case filter_type_1.FilterType.PREVIOUS:
            case filter_type_1.FilterType.NEXT:
            case filter_type_1.FilterType.SPECIFIED:
            case filter_type_1.FilterType.UNSPECIFIED: {
                return false;
            }
            default: {
                return true;
            }
        }
    };
    FilterItem.prototype.isIndicatorCategory = function () {
        return this.item instanceof category_item_dto_1.CategoryItemDto && this.item.searchCategoryName && this.item.searchCategoryName === FilterItem.INDICATOR_SYSTEM_NAME;
    };
    FilterItem.INDICATOR_SYSTEM_NAME = 'Indicator';
    return FilterItem;
}());
exports.FilterItem = FilterItem;
var templateObject_1;
//# sourceMappingURL=filter-item.js.map